<template>
    <div>
        <van-form  @submit="onSubmit">
            <van-field
                    name="upperInfoId"
                    v-model="formData.upperInfoId"
                    style="display: none"
            />
    <van-collapse v-model="subActivate" @change="collapseChange" :accordion="true" >
        <van-collapse-item title="上家信息">
            <van-field
                    label="上家单位名称:"
                    placeholder="请输入上家单位名称"
                    label-width="100px"
                    input-align="left"
                    name="unitName"
                    v-model="formData.unitName"
                    :rules="[{ required: true, message: '请输入上家单位名称' }]"
            />
            <van-field
                    readonly
                    clickable
                    name="upperNature"
                    :value="formData.upperNature"
                    label="上家性质:"
                    placeholder="点击选择"
                    label-width="100px"
                    input-align="left"
                    @click=" showPicker = true"
                    :rules="[{ required: true, message: '请选择上家性质' }]"
            />
            <van-popup v-model="showPicker" position="bottom">
                <van-picker
                        show-toolbar
                        :columns="upperNatures"
                        @confirm="onConfirm"
                        @cancel="showPicker = false"
                />
            </van-popup>
            <van-field
                    label="上家地址:"
                    placeholder="请输入上家地址"
                    label-width="100px"
                    input-align="left"
                    name="contactAddress"
                    v-model="formData.contactAddress"
                    :rules="[{ required: true, message: '请输入上家地址' }]"
            />
            <van-field
                    label="联系人姓名:"
                    placeholder="请输入联系人姓名"
                    label-width="100px"
                    input-align="left"
                    name="contactName"
                    v-model="formData.contactName"
                    :rules="[{ required: true, message: '请输入联系人姓名' }]"
            />
            <van-field
                    label="联系方式:"
                    placeholder="请输入联系方式"
                    label-width="100px"
                    input-align="left"
                    name="contractPhone"
                    v-model="formData.contractPhone"
                    :rules="[{ required: true, message: '请输入联系方式' }]"
            />
        </van-collapse-item>
        <van-collapse-item title="欠款信息">
            <van-field
                    label="全部借款人姓名:"
                    placeholder="请输入全部借款人姓名"
                    label-width="100px"
                    input-align="left"
                    name="customerName"
                    v-model="formData.customerName"
                    :rules="[{ required: true, message: '请输入全部借款人姓名' }]"
            />
            <van-field
                    label="抵押物是否与我司借款申请一致:"
                    label-width="100px"
                    input-align="left"
                    name="mortgageSame"
                    readonly
                    :rules="[{ required: true, message: '请选择抵押物是否与我司借款申请一致' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.mortgageSame" direction="horizontal"  >
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否"><span style="color: red">否</span></van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="上家是否公证:"
                    label-width="100px"
                    input-align="left"
                    name="notarization"
                    readonly
                    :rules="[{ required: true, message: '请选择上家是否公证' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.notarization" direction="horizontal" >
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="抵押物情况:"
                    label-width="100px"
                    input-align="left"
                    name="mortgageInfo"
                    readonly
                    :rules="[{ required: true, message: '请选择抵押物情况' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.mortgageInfo" direction="horizontal" >
                        <van-radio name="一押">一押</van-radio>
                        <van-radio name="二押">二押</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="存在关联贷款:"
                    label-width="100px"
                    input-align="left"
                    name="relationLoan"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.relationLoan" direction="horizontal" @change="onRelationLoanChange">
                        <van-radio name="是"><span style="color: red">是</span></van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-if="relationLoanShow"
                    label="该笔贷款为:"
                    placeholder="请输入该笔贷款为"
                    label-width="100px"
                    input-align="left"
                    name="loanRemark"
                    v-model="formData.loanRemark"
                    :rules="[{ required: true, message: '请输入该笔贷款为' }]"
            />
            <van-field
                        label="本金欠款(元):"
                        clickable
                        name="principalArrears"
                        :value="formData.principalArrears"
                        @click.native.stop="principalShow = true"
                        :rules="[{ required: true, message: '请输入本金欠款' }]"
                        readonly
            >
            </van-field>

            <van-number-keyboard
                    :show="principalShow"
                    extra-key="."
                    close-button-text="完成"
                    @blur="onCalculation('principalShow')"
                    v-model="formData.principalArrears"
            />
            <van-field
                    label="利息欠款(元):"
                    clickable
                    name="interestArrears"
                    :value="formData.interestArrears"
                    @click.native.stop="interestShow = true"
                    :rules="[{ required: true, message: '请输入利息欠款' }]"
                    readonly
            >
            </van-field>

            <van-number-keyboard
                    :show="interestShow"
                    extra-key="."
                    close-button-text="完成"
                    @blur="onCalculation('interestShow')"
                    v-model="formData.interestArrears"
            />
            <van-field
                    label="是否逾期:"
                    label-width="100px"
                    input-align="left"
                    name="overdue"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.overdue" direction="horizontal" @change="onOverDueChange">
                        <van-radio name="是"><span style="color: red">是</span></van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-if="overDueShow"
                    label="逾期类型:"
                    label-width="100px"
                    input-align="left"
                    name="overdueType"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.overdueType" direction="horizontal">
                        <van-radio name="本金逾期"><span style="color: red">本金逾期</span></van-radio>
                        <van-radio name="利息逾期">利息逾期</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-if="overDueShow"
                    label="逾期金额(元):"
                    clickable
                    name="overdueAmount"
                    :value="formData.overdueAmount"
                    @click.native.stop="overdueAmountShow = true"
                    :rules="[{ required: true, message: '请输入逾期金额' }]"
                    readonly
            >
            </van-field>

            <van-number-keyboard
                    :show="overdueAmountShow"
                    extra-key="."
                    close-button-text="完成"
                    @blur="overdueAmountShow = false"
                    v-model="formData.overdueAmount"
            />
            <van-field v-if="overDueShow"
                    label="逾期是否产生罚息:"
                    label-width="100px"
                    input-align="left"
                    name="penalty"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.penalty" direction="horizontal">
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-if="overDueShow"
                       label="逾期是否上征信:"
                       label-width="100px"
                       input-align="left"
                       name="credit"
                       readonly
                       :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.credit" direction="horizontal">
                        <van-radio name="是"><span style="color: red">是</span></van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                       label="罚息欠款（含提还违约金）(元):"
                       clickable
                       name="penaltyAmount"
                       :value="formData.penaltyAmount"
                       @click.native.stop="penaltyAmountShow = true"
                       :rules="[{ required: true, message: '请输入罚息欠款（含提还违约金）' }]"
                       readonly
            >
            </van-field>

            <van-number-keyboard
                    :show="penaltyAmountShow"
                    extra-key="."
                    close-button-text="完成"
                    @blur="onCalculation('penaltyAmountShow')"
                    v-model="formData.penaltyAmount"
            />
            <van-field
                       label="上家总欠款(元):"
                       clickable
                       name="upperTotalArrears"
                       :value="formData.upperTotalArrears"
                       :rules="[{ required: true, message: '请输入上家总欠款' }]"
                       readonly
            >
            </van-field>

            <van-number-keyboard
                    :show="upperTotalArrearsShow"
                    extra-key="."
                    close-button-text="完成"
                    @blur="upperTotalArrearsShow = false"
                    v-model="formData.upperTotalArrears"
            />
        </van-collapse-item>
        <van-collapse-item title="交接信息">
            <van-field
                    label="上家到期日期:"
                    clickable
                    :value="formData.upperDueDate"
                    @click.native.stop="upperDueDateShow = true"
                    readonly
                    name="upperDueDate"
                    :rules="[{ required: true, message: '请选择上家到期日期' }]"
            >
            </van-field>
            <van-calendar v-model="upperDueDateShow" :max-date="maxDate" @confirm="onUpperDueDateConfirm" />
            <van-field
                       label="上家是否收押房本:"
                       label-width="100px"
                       input-align="left"
                       name="collectProperty"
                       readonly
                       :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.collectProperty" direction="horizontal" @change="onCollectPropertyChange">
                        <van-radio name="是">是</van-radio>
                        <van-radio name="否">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field v-if="collectPropertyShow"
                       label="房本所在:"
                       placeholder="请输入房本所在"
                       label-width="100px"
                       input-align="left"
                       name="propertyLocation"
                       v-model="formData.propertyLocation"
                       :rules="[{ required: true, message: '请输入房本所在' }]"
            />
            <van-field
                    label="还款当天能否拿房本:"
                    label-width="100px"
                    input-align="left"
                    name="propertyObtain"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.propertyObtain" direction="horizontal">
                        <van-radio name="能">能</van-radio>
                        <van-radio name="不能">不能</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                       label="具体拿到房本的时间节点:"
                       placeholder="请输入具体拿到房本的时间节点"
                       label-width="100px"
                       input-align="left"
                       name="propertyObtainDate"
                       v-model="formData.propertyObtainDate"
                       :rules="[{ required: true, message: '请输入具体拿到房本的时间节点' }]"
            />
            <van-field
                    label="能否提前还款:"
                    label-width="100px"
                    input-align="left"
                    name="prepay"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.prepay" direction="horizontal">
                        <van-radio name="能">能</van-radio>
                        <van-radio name="不能">不能</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="提前还款方式:"
                    label-width="100px"
                    input-align="left"
                    name="prepayMode"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.prepayMode" direction="horizontal">
                        <van-radio name="提前预约">提前预约</van-radio>
                        <van-radio name="随借随还">随借随还</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="预约还款日期:"
                    clickable
                    :value="formData.orderRepayDate"
                    @click.native.stop="orderRepayDateShow = true"
                    readonly
                    name="orderRepayDate"
                    :rules="[{ required: true, message: '请选择预约还款日期' }]"
            >
            </van-field>
            <van-calendar v-model="orderRepayDateShow" @confirm="onOrderRepayDateConfirm" />
            <van-field
                    label="还款方式:"
                    label-width="100px"
                    input-align="left"
                    name="repayMode"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.repayMode" direction="horizontal" @change="onRepayModeChange">
                        <van-radio name="自动划扣">自动划扣</van-radio>
                        <van-radio name="线下还款">线下还款</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
        </van-collapse-item>
        <van-collapse-item title="出借账户信息" v-if="repayModeShow">
            <van-field
                    label="出借人户名:"
                    placeholder="请输入上家出借人户名"
                    label-width="100px"
                    input-align="left"
                    name="bankName"
                    v-model="formData.bankName"
                    :rules="[{ required: true, message: '请输入上家出借人户名' }]"
            />
            <van-field
                    label="账号:"
                    placeholder="请输入账号"
                    label-width="100px"
                    input-align="left"
                    name="bankAccount"
                    v-model="formData.bankAccount"
                    :rules="[{ required: true, message: '请输入账号' }]"
            />
            <van-field
                    label="开户行:"
                    placeholder="请输入开户行"
                    label-width="100px"
                    input-align="left"
                    name="accountBank"
                    v-model="formData.accountBank"
                    :rules="[{ required: true, message: '请输入开户行' }]"
            />
            <van-field
                    readonly
                    clickable
                    name="repayAccountSame"
                    :value="formData.repayAccountSame"
                    label="本次垫资的上家还款账户:"
                    placeholder="点击选择"
                    label-width="100px"
                    input-align="left"
                    @click="showAccountSamePicker = true"
                    :rules="[{ required: true, message: '请选择' }]"
            />
            <van-popup v-model="showAccountSamePicker" position="bottom">
                <van-picker
                        show-toolbar
                        :columns="repayAccountSames"
                        @confirm="onRepayAccountConfirm"
                        @cancel="showAccountSamePicker = false"
                />
            </van-popup>
            <van-field v-if="repayAccountSameShow"
                    label="不一致的原因表述:"
                    placeholder="请输入不一致的原因表述"
                    label-width="100px"
                    input-align="left"
                    name="bankDifRemark"
                    v-model="formData.bankDifRemark"
                    :rules="[{ required: true, message: '请输入不一致的原因表述' }]"
            />
            <van-field v-if="repayAccountSameShow"
                       label="上家还款账户户名:"
                       placeholder="请输入上家还款账户户名"
                       label-width="100px"
                       input-align="left"
                       name="repayBankName"
                       v-model="formData.repayBankName"
                       :rules="[{ required: true, message: '请输入上家还款账户户名' }]"
            />
            <van-field v-if="repayAccountSameShow"
                       label="上家还款账号:"
                       placeholder="请输入上家还款账号"
                       label-width="100px"
                       input-align="left"
                       name="repayBankAccount"
                       v-model="formData.repayBankAccount"
                       :rules="[{ required: true, message: '请输入上家还款账号' }]"
            />
            <van-field v-if="repayAccountSameShow"
                       label="上家还款账户开户支行:"
                       placeholder="请输入上家还款账户开户支行"
                       label-width="100px"
                       input-align="left"
                       name="repayAccountBank"
                       v-model="formData.repayAccountBank"
                       :rules="[{ required: true, message: '请输入上家还款账户开户支行' }]"
            />
        </van-collapse-item>
        <van-collapse-item title="借款账户信息">
            <van-field
                       label="借款卡户名	:"
                       placeholder="请输入借款卡户名"
                       label-width="100px"
                       input-align="left"
                       name="customerAccountName"
                       v-model="formData.customerAccountName"
                       :rules="[{ required: true, message: '请输入借款卡户名' }]"
            />
            <van-field
                    label="借款账号:"
                    placeholder="请输入借款账号"
                    label-width="100px"
                    input-align="left"
                    name="customerBankAccount"
                    v-model="formData.customerBankAccount"
                    :rules="[{ required: true, message: '请输入借款账号' }]"
            />
            <van-field
                    label="开户支行:"
                    placeholder="请输入开户支行"
                    label-width="100px"
                    input-align="left"
                    name="customerBankName"
                    v-model="formData.customerBankName"
                    :rules="[{ required: true, message: '请输入开户支行' }]"
            />
            <van-field
                    readonly
                    clickable
                    name="receiveMode"
                    :value="formData.receiveMode"
                    label="解押材料领取方式:"
                    placeholder="点击选择"
                    label-width="100px"
                    input-align="left"
                    @click="showReceiveModePicker = true"
                    :rules="[{ required: true, message: '请选择' }]"
            />
            <van-popup v-model="showReceiveModePicker" position="bottom">
                <van-picker
                        show-toolbar
                        :columns="receiveModes"
                        @confirm="onReceiveModeConfirm"
                        @cancel="showReceiveModePicker = false"
                />
            </van-popup>
            <van-field
                    label="解押材料预计领取日期:"
                    clickable
                    :value="formData.receiveDate"
                    @click.native.stop="receiveDateShow = true"
                    readonly
                    name="receiveDate"
                    :rules="[{ required: true, message: '请选择解押材料预计领取日期' }]"
            >
            </van-field>
            <van-calendar v-model="receiveDateShow" @confirm="onReceiveDateConfirm" />
            <van-field
                    label="解押方式:"
                    label-width="100px"
                    input-align="left"
                    name="unzipMode"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.unzipMode" direction="horizontal" >
                        <van-radio name="陪同客户解押">陪同客户解押</van-radio>
                        <van-radio name="线上自行解押">线上自行解押</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    label="上家配合度:"
                    label-width="100px"
                    input-align="left"
                    name="cooperationDegree"
                    readonly
                    :rules="[{ required: true, message: '请选择' }]"
            >
                <template #input>
                    <van-radio-group v-model="formData.cooperationDegree" direction="horizontal" >
                        <van-radio name="高">高</van-radio>
                        <van-radio name="一般">一般</van-radio>
                        <van-radio name="不愿配合">不愿配合</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                       readonly
                       clickable
                       name="sourceCheck"
                       :value="formData.sourceCheck"
                       label="信息来源核对:"
                       placeholder="点击选择"
                       label-width="100px"
                       input-align="left"
                       :rules="[{ required: true, message: '请选择信息来源核对' }]"
                       @click="showSourceCheck = true"

            />
            <van-popup v-model="showSourceCheck" position="bottom">
                <van-cell
                        title="已选择"
                        left>
                    <template>
                        <van-tag plain round closeable type="success"  size="medium"  v-for="(item,index) in sourceCheckSelected" :key="index" @close="onClose(item)" @click="onClose(item)">{{item}}</van-tag>
                    </template>
                </van-cell>

                <van-picker
                        show-toolbar
                        :columns="sourceChecks"
                        @confirm="onSourceCheckConfirm"
                        @cancel="showSourceCheck = false"
                        @change="onSourceCheckChange"
                />
            </van-popup>
            <van-field
                    label="补充说明:"
                    placeholder="补充说明"
                    label-width="100px"
                    input-align="left"
                    name="handoverDegree"
                    v-model="formData.handoverDegree"
            />
        </van-collapse-item>
        <van-collapse-item :title="title">
            <!--<FilesUpload style="margin-top: 10px;" :applyId="applyId" :groupCode="groupCode" :refName="bankType" :isUpload="true"></FilesUpload>-->
            <oss-upload style="margin-top: 10px;" :applyId="applyId" :groupCode="groupCode" :refName="bankType" :isUpload="true"></oss-upload>
        </van-collapse-item>
    </van-collapse>


    <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" :loading="loading">
            保存
        </van-button>
    </div>
        </van-form>
    </div>
</template>

<script>
    import {saveUpperBank,findUpperBank} from '@/api/foreclosure'
    import { uuid } from '@/vue/utils/util'
    import Vue from 'vue'
    import { Toast } from 'vant'
    import ossUpload from '@/views/component/oss-upload'
    Vue.use(Toast)
    import { debounce,cloneDeep } from 'lodash'
    import FilesUpload from '../../business/mortgage/files-upload'
    export default {
        name: 'upper_bank_edit',
        components: {
            FilesUpload,
            ossUpload
        },
        props: {
            applyId: {
                type: String,
                default: ''
            },
            bankType: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                formData:{},
                subActivate: [],
                loading:false,
                showPicker:false,
                title:'上家一押影像资料',
                groupCode:900,
                upperNatures:['个人','机构','银行'],
                repayAccountSames:['与上家出借账户信息一致','与上家出借账户信息不一致'],
                receiveModes:['客户持身份证领取','委托权证领取'],
                sourceChecks:['经办口述','系统核对'],
                relationLoanShow:false,
                principalShow:false,
                interestShow:false,
                overDueShow:false,
                overdueAmountShow:false,
                penaltyAmountShow:false,
                upperTotalArrearsShow:false,
                upperDueDateShow:false,
                collectPropertyShow:false,
                orderRepayDateShow:false,
                repayModeShow:false,
                showAccountSamePicker:false,
                repayAccountSameShow:false,
                showReceiveModePicker:false,
                receiveDateShow:false,
                showSourceCheck:false,
                sourceCheckSelected:[],
                maxDate: new Date(2050, 11, 31),
            }
        },
        mounted() {
            this.loadData()
            const titleMap = {
                'one': '上家一押影像资料',
                'second': '上家二押影像资料'
            }
            const groupCodeMap={
                'one': 900,
                'second': 901
            }
            this.title=titleMap[this.bankType]
            this.groupCode=groupCodeMap[this.bankType]
        },
        methods: {
            collapseChange(array) {
            },
            //日期格式化
            formatDate(date) {
                var ft=Vue.filter('dateYmdFormat')
                return ft(date)
            },
            onConfirm(value){
                this.formData.upperNature = value;
                this.showPicker = false;
            },
            onRepayAccountConfirm(value){
                this.formData.repayAccountSame = value;
                this.showAccountSamePicker = false;
                this.repayAccountSameShow=(value=="与上家出借账户信息不一致")
            },
            onReceiveModeConfirm(value){
                this.formData.receiveMode = value;
                this.showReceiveModePicker = false;
            },
            onRelationLoanChange(value){
                this.relationLoanShow=(value=='是')
            },
            //是否逾期
            onOverDueChange(value){
                this.overDueShow=(value=='是')
            },
            //是否保存房本
            onCollectPropertyChange(value){
                this.collectPropertyShow=(value=='否')
            },
            //还款方式
            onRepayModeChange(value){
                this.repayModeShow=(value=='线下还款')
            },
            onUpperDueDateConfirm(date){
                this.upperDueDateShow = false;
                this.formData.upperDueDate = this.formatDate(date);
            },
            onOrderRepayDateConfirm(date){
                this.orderRepayDateShow = false;
                this.formData.orderRepayDate = this.formatDate(date);
            },
            onReceiveDateConfirm(date){
                this.receiveDateShow = false;
                this.formData.receiveDate = this.formatDate(date);
            },
            onClose(value){
                if(this.sourceCheckSelected.includes(value))
                    this.sourceCheckSelected.splice(this.sourceCheckSelected.findIndex(item => item===value), 1)
            },
            onSourceCheckConfirm(value,index){
                this.formData.sourceCheck = this.sourceCheckSelected.join(",");
                this.showSourceCheck = false;
            },
            onSourceCheckChange(picker, value, index){
                if(!this.sourceCheckSelected.includes(value))
                    this.sourceCheckSelected.push(value)
            },
            //计算上家总欠款
            onCalculation(value){
                this.$data[value]=false
                let principalArrears=this.formData.principalArrears|0
                let interestArrears=this.formData.interestArrears|0
                let penaltyAmount=this.formData.penaltyAmount|0
                let upperTotalArrears=parseFloat(principalArrears)+parseFloat(interestArrears)+parseFloat(penaltyAmount)
                this.formData.upperTotalArrears=upperTotalArrears
            },
            onSubmit(values){
                let self=this
                let params=cloneDeep(values)
                params=Object.assign(self.formData,params)
                if(params.upperInfoId==null){
                    const upperInfoId=uuid()
                    params.upperInfoId=upperInfoId
                }
                params.applyId=self.applyId
                params.type=self.bankType
                self.loading=true
                saveUpperBank(params).then(res => {
                    if(res.success){
                        Toast.success(res.msg);
                    }else{
                        Toast.fail(res.msg);
                    }
                    this.loading=false
                })
            },
            loadData(){
                let self=this
                findUpperBank({applyId:self.applyId}).then(res => {
                    if(res.success){
                        let upperBank=res.data.filter(bank=>bank.type==self.bankType)[0]||{}
                        let formData=cloneDeep(upperBank)
                        //日期处理
                        formData.upperDueDate!=null?(formData.upperDueDate = this.formatDate(formData.upperDueDate)):''
                        formData.orderRepayDate!=null?(formData.orderRepayDate = this.formatDate(formData.orderRepayDate)):''
                        formData.receiveDate!=null?(formData.receiveDate = this.formatDate(formData.receiveDate)):''
                        formData.operateDate!=null?(formData.operateDate = this.formatDate(formData.operateDate)):''
                        //显示字段处理
                        self.overDueShow=(formData.overdue=='是')
                        self.relationLoanShow=(formData.relationLoan=='是')
                        self.repayModeShow=(formData.repayMode=='线下还款')
                        self.collectPropertyShow=(formData.collectProperty=='否')
                        self.repayAccountSameShow=(formData.repayAccountSame=='与上家出借账户信息不一致')
                        //数值处理
                        formData.principalArrears=formData.principalArrears!=null?(formData.interestArrears.toString()):''
                        formData.interestArrears=formData.interestArrears!=null?(formData.interestArrears.toString()):''
                        formData.overdueAmount=formData.overdueAmount!=null?(formData.overdueAmount.toString()):''
                        formData.penaltyAmount=formData.penaltyAmount!=null?(formData.penaltyAmount.toString()):''
                        formData.upperTotalArrears=formData.upperTotalArrears!=null?(formData.upperTotalArrears.toString()):''
                        //多选处理
                        self.sourceCheckSelected=(formData.sourceCheck!=null?formData.sourceCheck.split(","):[])
                        debounce(() => {
                            this.formData=formData
                        }, 1000)()
                    }
                })
            }

        }
    }
</script>

<style scoped>

</style>
